import { render, staticRenderFns } from "./motoristaTransportes.vue?vue&type=template&id=08acef32&"
import script from "./motoristaTransportes.vue?vue&type=script&lang=js&"
export * from "./motoristaTransportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports